export default "__VITE_ASSET__DuaCIUMD__"